import React from 'react';

const BaseContext = React.createContext({
  navigateTo: (destionation) => {},
  windowHeight: 0,
  conversationBodyHeight: 0,
  contactBodyHeight: 0,
  profilBodyHeight: 0,
  messageEditorPositionBottom: 0,
  resizeSectionConversation: (emojiStatus) => {},
  sendMessage: (message) => {},
  removeMessage: (id) => {},
  discussionId: null
});

const ConversationContext = React.createContext({
  idMessageIndexed: null,
  setIdMessageIndexed: (id) => {}
})

export { BaseContext, ConversationContext };
